/**
 * Coloroutine AI Creative Studio — Bundled JS
 * Generated: 2026-07-29T07:24:57.894Z
 * Build: node scripts/build-bundle.js
 * ALL modules share one scope — classes are visible across files.
 */
(function() {
'use strict';

// DEBUG: catch ALL JS errors and show them on-screen
window.__CR_ERRORS__ = [];
window.addEventListener('error', function(e) {
  var msg = e.message + (e.filename ? ' @ ' + e.filename.split('/').pop() : '') + ':' + e.lineno;
  window.__CR_ERRORS__.push(msg);
  var loader = document.getElementById('ai-studio-loader');
  if (loader) {
    loader.innerHTML = '<div class="loader-text" style="color:#FF6B6B;font-size:0.8rem;white-space:pre-wrap;text-align:left;max-width:600px;">' +
      window.__CR_ERRORS__.join('<br>') + '<br><br>🔍 Open DevTools for full stack trace</div>';
  } else {
    console.error('[Coloroutine]', msg);
  }
});

const Studio = window.ColoroutineStudio = {};
const API_BASE = (function() {
  const el = document.querySelector('ai-design-studio');
  return (el && el.getAttribute('api-base')) || 'http://localhost:3001/api';
})();


// ===== components/mode-cards.js =====
/**
 * Mode Cards — 4-mode selector (cards, NOT tabs).
 */

const MODES = [
  {
    id: 'upload',
    icon: '📤',
    label: '上传设计',
    desc: '拖拽你的图片开始创作'
  },
  {
    id: 'text-to-image',
    icon: '✍️',
    label: 'AI 文字生成',
    desc: '描述你的创意，AI 为你出图'
  },
  {
    id: 'image-to-image',
    icon: '🖼️',
    label: 'AI 参考图生成',
    desc: '上传参考图 + 描述，AI 融合创作'
  },
  {
    id: 'inspiration',
    icon: '💡',
    label: '灵感推荐',
    desc: '浏览趋势和季节灵感'
  }
];

class ModeCards {
  constructor(container, { onModeChange }) {
    this.container = container;
    this.onModeChange = onModeChange;
    this.activeMode = null;
    this.render();
  }

  render() {
    this.container.innerHTML = `
      <div class="mode-cards">
        ${MODES.map(m => `
          <div class="mode-card" data-mode="${m.id}">
            <div class="mode-icon">${m.icon}</div>
            <div class="mode-label">${m.label}</div>
            <div class="mode-desc">${m.desc}</div>
          </div>
        `).join('')}
      </div>`;

    this.container.querySelectorAll('.mode-card').forEach(card => {
      card.addEventListener('click', () => {
        const mode = card.dataset.mode;
        this.setActive(mode);
        this.onModeChange(mode);
      });
    });
  }

  setActive(mode) {
    this.activeMode = mode;
    this.container.querySelectorAll('.mode-card').forEach(card => {
      card.classList.toggle('active', card.dataset.mode === mode);
    });
  }
}


// ===== canvas/design-canvas.js =====
/**
 * Design Canvas v2 — Fabric.js canvas with print area + zoom + product background.
 */
class DesignCanvas {
  constructor(container, { width = 500, height = 600, productType = 'tshirt' }) {
    this.container = container;
    this.width = width;
    this.height = height;
    this.productType = productType;
    this.canvas = null;
    this.printArea = null;
    this.mounted = false;
    this.zoom = 1;
    this.zoomStep = 0.15;
    this.currentDesignImage = null;
  }

  mount(containerEl) {
    if (this.mounted && this.canvas) { this.canvas.dispose(); }
    this.container = containerEl || this.container;
    this.container.innerHTML = '';

    const el = document.createElement('canvas');
    el.width = this.width;
    el.height = this.height;
    el.style.borderRadius = 'var(--cr-radius-md, 12px)';
    el.style.boxShadow = 'var(--cr-card-shadow, 0 2px 16px rgba(0,0,0,0.06))';
    this.container.appendChild(el);

    this.canvas = new fabric.Canvas(el, {
      width: this.width,
      height: this.height,
      backgroundColor: '#F5F0EB',
      preserveObjectStacking: true,
      centeredScaling: true,
      uniScaleTransform: true,
      selection: true,
      renderOnAddRemove: true
    });

    this._createPrintArea();
    this._addZoomControls();
    this._enableMouseWheelZoom();

    this.canvas.on('object:moving', (e) => this._constrainToPrintArea(e.target));
    this.canvas.on('object:scaling', (e) => this._constrainToPrintArea(e.target));

    this.mounted = true;
  }

  _enableMouseWheelZoom() {
    if (!this.canvas) return;
    this.canvas.on('mouse:wheel', (opt) => {
      const delta = opt.e.deltaY;
      const zoom = this.canvas.getZoom();
      const factor = delta > 0 ? 1 - this.zoomStep : 1 + this.zoomStep;
      const newZoom = Math.max(0.3, Math.min(4, zoom * factor));
      this.canvas.zoomToPoint({ x: opt.pointer.x, y: opt.pointer.y }, newZoom);
      this.zoom = newZoom;
      this._updateZoomDisplay();
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });
  }

  _addZoomControls() {
    if (!this.canvas) return;
    const controls = document.createElement('div');
    controls.style.cssText = 'display:flex;gap:8px;align-items:center;padding:8px 0;';
    controls.innerHTML = `
      <button id="zoomOut" style="background:var(--cr-bg-primary,#fff);border:1px solid var(--cr-border,#e2e8f0);border-radius:6px;padding:4px 10px;cursor:pointer;font-size:14px;line-height:1;">−</button>
      <span id="zoomLevel" style="font-size:12px;color:var(--cr-text-secondary,#64748b);min-width:45px;text-align:center;">100%</span>
      <button id="zoomIn" style="background:var(--cr-bg-primary,#fff);border:1px solid var(--cr-border,#e2e8f0);border-radius:6px;padding:4px 10px;cursor:pointer;font-size:14px;line-height:1;">+</button>
      <button id="zoomFit" style="background:var(--cr-bg-primary,#fff);border:1px solid var(--cr-border,#e2e8f0);border-radius:6px;padding:4px 10px;cursor:pointer;font-size:11px;">Fit</button>`;
    this.container.appendChild(controls);

    controls.querySelector('#zoomOut').addEventListener('click', () => this.zoomBy(-1));
    controls.querySelector('#zoomIn').addEventListener('click', () => this.zoomBy(1));
    controls.querySelector('#zoomFit').addEventListener('click', () => this.fitDesign());
  }

  zoomBy(dir) {
    if (!this.canvas) return;
    const zoom = this.canvas.getZoom();
    const factor = dir < 0 ? 1 - this.zoomStep : 1 + this.zoomStep;
    this.setZoom(Math.max(0.3, Math.min(4, zoom * factor)));
  }

  setZoom(level) {
    if (!this.canvas) return;
    this.canvas.setZoom(level);
    this.zoom = level;
    this._updateZoomDisplay();
  }

  _updateZoomDisplay() {
    const el = this.container.querySelector('#zoomLevel');
    if (el) el.textContent = Math.round(this.zoom * 100) + '%';
  }

  fitDesign() {
    if (!this.canvas || !this.currentDesignImage) return;
    const img = this.currentDesignImage;
    const pa = this._getPrintAreaSpecs();
    const fitW = pa.w / img.width;
    const fitH = pa.h / img.height;
    const zoom = Math.min(fitW, fitH, 2);
    this.canvas.setZoom(zoom);
    this.zoom = zoom;
    this._updateZoomDisplay();

    // Recenter design in viewport
    const vpt = this.canvas.viewportTransform;
    vpt[4] = this.width / 2 - (img.left + img.width * img.scaleX / 2) * zoom;
    vpt[5] = this.height / 2 - (img.top + img.height * img.scaleY / 2) * zoom;
    this.canvas.requestRenderAll();
  }

  setProductBackground(colorHex) {
    if (!this.canvas) return;
    this.canvas.backgroundColor = colorHex || '#F5F0EB';
    this.canvas.renderAll();
  }

  _createPrintArea() {
    const specs = this._getPrintAreaSpecs();
    const { x, y, w, h } = specs;
    this.printArea = new fabric.Rect({
      left: x, top: y, width: w, height: h,
      fill: 'transparent', stroke: '#FF6B6B', strokeWidth: 2,
      strokeDashArray: [8, 4],
      selectable: false, evented: false, excludeFromExport: true, name: 'print-area-guide'
    });
    this.canvas.add(this.printArea);
    this.canvas.renderAll();
  }

  _getPrintAreaSpecs() {
    const marginX = this.width * 0.1, marginY = this.height * 0.1;
    return { x: marginX, y: marginY, w: this.width - marginX * 2, h: this.height - marginY * 2 };
  }

  _constrainToPrintArea(obj) {
    if (!this.printArea || !obj) return;
    const pa = this.printArea;
    obj.setCoords();
    if (obj.left < pa.left) obj.left = pa.left;
    if (obj.top < pa.top) obj.top = pa.top;
    if (obj.left + obj.width * obj.scaleX > pa.left + pa.width)
      obj.left = pa.left + pa.width - obj.width * obj.scaleX;
    if (obj.top + obj.height * obj.scaleY > pa.top + pa.height)
      obj.top = pa.top + pa.height - obj.height * obj.scaleY;
    obj.setCoords();
  }

  async loadImage(url) {
    if (!this.canvas) return;

    // Clear previous design objects
    const objects = this.canvas.getObjects();
    objects.forEach(obj => { if (obj !== this.printArea) this.canvas.remove(obj); });
    this.currentDesignImage = null;

    const img = await new Promise((resolve, reject) => {
      fabric.Image.fromURL(url, (img) => {
        if (!img) return reject(new Error('Failed to load image'));
        resolve(img);
      }, { crossOrigin: 'anonymous' });
    });

    const pa = this._getPrintAreaSpecs();
    const maxW = pa.w * 0.8, maxH = pa.h * 0.8;
    if (img.width > maxW || img.height > maxH) {
      const scale = Math.min(maxW / img.width, maxH / img.height);
      img.scaleX = scale; img.scaleY = scale;
    }
    img.set({
      left: pa.x + (pa.w - img.width * img.scaleX) / 2,
      top: pa.y + (pa.h - img.height * img.scaleY) / 2
    });
    img.setCoords();
    this.canvas.add(img);
    this.canvas.setActiveObject(img);
    this.canvas.renderAll();

    this.currentDesignImage = img;
    return img;
  }

  exportDesign() {
    if (!this.canvas) return null;
    if (this.printArea) this.printArea.visible = false;
    this.canvas.renderAll();
    const dataUrl = this.canvas.toDataURL({ format: 'png', multiplier: 4, enableRetinaScaling: true });
    if (this.printArea) this.printArea.visible = true;
    this.canvas.renderAll();
    return dataUrl;
  }

  dispose() {
    if (this.canvas) { this.canvas.dispose(); this.canvas = null; }
    this.mounted = false;
  }
}


// ===== ai/generate-panel.js =====
/**
 * Generate Panel — AI text-to-image and image-to-image UI.
 */

const STYLE_CHIPS = [
  { id: 'kawaii',      label: '🌸 可爱日系' },
  { id: 'minimalist',  label: '◻️ 极简主义' },
  { id: 'streetwear',  label: '🔥 街头潮流' },
  { id: 'watercolor',  label: '🎨 水彩艺术' },
  { id: 'cyberpunk',   label: '🌃 赛博朋克' },
  { id: 'vintage_retro', label: '📻 复古怀旧' },
  { id: 'geometric',   label: '🔷 几何图形' },
  { id: 'hand_drawn',  label: '✏️ 手绘风格' }
];

class GeneratePanel {
  constructor(container, { onGenerate, apiBase }) {
    this.container = container;
    this.onGenerate = onGenerate;
    this.apiBase = apiBase;
    this.currentMode = 'text-to-image';
    this.selectedStyle = 'kawaii';
    this.referenceImage = null;
  }

  mount(containerEl, mode) {
    this.container = containerEl || this.container;
    this.currentMode = mode;
    this.render();
    this.bindEvents();
  }

  remount() {
    this.render();
    this.bindEvents();
  }

  render() {
    const isImageMode = this.currentMode === 'image-to-image';

    this.container.innerHTML = `
      <div class="generate-panel">
        <textarea class="prompt-input" id="promptInput"
          placeholder="描述你心中的画面，比如'一只在星球上弹吉他的猫'…"
          rows="3"></textarea>

        <div style="margin-top: var(--cr-md);">
          <label style="font-size:0.85rem; font-weight:600; display:block; margin-bottom: var(--cr-sm);">
            ✨ 选择风格
          </label>
          <div class="style-selector" id="styleSelector">
            ${STYLE_CHIPS.map(s => `
              <div class="style-chip${s.id === this.selectedStyle ? ' active' : ''}"
                   data-style="${s.id}">${s.label}</div>
            `).join('')}
          </div>
        </div>

        ${isImageMode ? `
        <div style="margin-top: var(--cr-md);">
          <label style="font-size:0.85rem; font-weight:600; display:block; margin-bottom: var(--cr-sm);">
            🖼️ 参考图片
          </label>
          <div class="upload-zone" id="refUploadZone" style="padding: var(--cr-lg);">
            <div class="upload-icon">🖼️</div>
            <div class="upload-text">上传一张参考图</div>
            <div class="upload-hint">AI 会参考这张图的风格和构图</div>
            <input type="file" id="refFileInput" accept="image/png,image/jpeg,image/webp" hidden>
          </div>
          <div id="refPreview" style="display:none; margin-top: var(--cr-sm); text-align:center;">
            <img id="refPreviewImg" style="max-width:150px; max-height:150px; border-radius: var(--cr-radius-sm);">
            <button class="btn-secondary" id="refRemoveBtn" style="margin-left: var(--cr-sm);">✕ 移除</button>
          </div>
        </div>` : ''}

        <button class="btn-primary" id="btnGenerate" style="width:100%; margin-top: var(--cr-lg);">
          ✨ 生成设计
        </button>
      </div>`;
  }

  bindEvents() {
    // Style chips
    this.container.querySelectorAll('.style-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        this.selectedStyle = chip.dataset.style;
        this.container.querySelectorAll('.style-chip').forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
      });
    });

    // Generate button
    const btn = this.container.querySelector('#btnGenerate');
    btn.addEventListener('click', () => {
      const userInput = this.container.querySelector('#promptInput').value;
      this.onGenerate({
        mode: this.currentMode,
        userInput,
        stylePreset: this.selectedStyle,
        referenceImage: this.referenceImage
      });
    });

    // Image reference (only for image-to-image mode)
    if (this.currentMode === 'image-to-image') {
      const refZone = this.container.querySelector('#refUploadZone');
      const refInput = this.container.querySelector('#refFileInput');
      const refPreview = this.container.querySelector('#refPreview');
      const refPreviewImg = this.container.querySelector('#refPreviewImg');
      const refRemoveBtn = this.container.querySelector('#refRemoveBtn');

      refZone.addEventListener('click', () => refInput.click());
      refInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.referenceImage = ev.target.result;
          refPreviewImg.src = ev.target.result;
          refPreview.style.display = 'block';
          refZone.style.display = 'none';
        };
        reader.readAsDataURL(file);
      });
      refRemoveBtn.addEventListener('click', () => {
        this.referenceImage = null;
        refPreview.style.display = 'none';
        refZone.style.display = 'block';
      });
    }
  }

  /**
   * Fill the prompt input with a pre-defined prompt (from inspiration).
   */
  fillPrompt(prompt, stylePreset) {
    const input = this.container.querySelector('#promptInput');
    if (input) {
      input.value = typeof prompt === 'object' ? (prompt.zh || prompt.en) : prompt;
      input.focus();
    }
    if (stylePreset) {
      this.selectedStyle = stylePreset;
      this.container.querySelectorAll('.style-chip').forEach(c => {
        c.classList.toggle('active', c.dataset.style === stylePreset);
      });
    }
  }
}


// ===== inspiration/inspiration-grid.js =====
/**
 * Inspiration Grid — Curated design ideas from API.
 */

class InspirationGrid {
  constructor(container, { productType, apiBase, onTryIdea }) {
    this.container = container;
    this.productType = productType;
    this.apiBase = apiBase;
    this.onTryIdea = onTryIdea;
    this.inspirations = [];
    this.rendered = false;
  }

  async refresh() {
    try {
      const res = await fetch(`${this.apiBase}/inspiration?productType=${this.productType}`);
      const data = await res.json();
      if (data.success) {
        this.inspirations = data.inspirations;
        this.render();
      }
    } catch {
      this.renderFallback();
    }
  }

  render() {
    if (this.inspirations.length === 0) {
      this.renderFallback();
      return;
    }

    this.container.innerHTML = `
      <div class="inspiration-stream">
        <h3>💡 发现你的下一个灵感</h3>
        <div class="inspiration-grid" id="inspirationGrid"></div>
      </div>`;

    const grid = this.container.querySelector('#inspirationGrid');
    const colorIcons = ['🌸', '🎨', '✨', '🌈', '💫', '🔥', '🌟', '🦋', '🌺', '🍀', '🎭', '💎'];

    this.inspirations.forEach((item, i) => {
      const card = document.createElement('div');
      card.className = 'inspiration-card';
      card.innerHTML = `
        <div class="inspiration-image">${colorIcons[i % colorIcons.length]}</div>
        <div class="inspiration-meta">
          <div class="inspiration-title">${item.title?.zh || item.title?.en || item.title}</div>
          <div class="inspiration-tags">
            ${(item.tags || []).map(t => `<span>#${t}</span>`).join(' ')}
          </div>
          <button class="try-btn">✨ 试一试</button>
        </div>`;

      card.querySelector('.try-btn').addEventListener('click', (e) => {
        e.stopPropagation();
        this.onTryIdea(
          item.prompt?.zh || item.prompt?.en || item.prompt,
          item.stylePreset
        );
      });

      grid.appendChild(card);
    });

    this.rendered = true;
  }

  renderFallback() {
    this.container.innerHTML = `
      <div class="inspiration-stream">
        <h3>💡 发现你的下一个灵感</h3>
        <div class="inspiration-grid">
          ${this.getStaticInspirations().map(item => `
            <div class="inspiration-card">
              <div class="inspiration-image">${item.icon}</div>
              <div class="inspiration-meta">
                <div class="inspiration-title">${item.title}</div>
                <div class="inspiration-tags">${item.tags}</div>
                <button class="try-btn">✨ 试一试</button>
              </div>
            </div>
          `).join('')}
        </div>
      </div>`;

    // Bind fallback cards
    this.container.querySelectorAll('.try-btn').forEach((btn, i) => {
      btn.addEventListener('click', () => {
        const item = this.getStaticInspirations()[i];
        this.onTryIdea(item.prompt, item.stylePreset);
      });
    });
  }

  getStaticInspirations() {
    return [
      { icon: '🌸', title: '夏日落日', tags: '#热带 #海滩', prompt: '热带落日与棕榈树剪影，渐变暖色调', stylePreset: 'watercolor' },
      { icon: '🐱', title: '宇宙猫', tags: '#猫 #星空', prompt: '一只可爱的猫漂浮在星空中', stylePreset: 'kawaii' },
      { icon: '🎨', title: '城市涂鸦', tags: '#街头 #霓虹', prompt: '大胆涂鸦风格，霓虹色彩泼溅', stylePreset: 'streetwear' },
      { icon: '🌃', title: '霓虹龙', tags: '#龙 #赛博', prompt: '赛博朋克风格龙，霓虹鳞片', stylePreset: 'cyberpunk' }
    ];
  }
}


// ===== components/preview-panel.js =====
/**
 * Preview Panel v6 — Robust 2D/3D preview with fallbacks
 * Fixes: missing mockup → fallback to baseImage/solid color
 * Fixes: Three.js bare specifier → esm.sh CDN
 * Fixes: 3D design positioning from templateConfig
 */
const COLOR_MAP = {
  black:'#2D2D2D', white:'#FFFFFF', navy:'#1B2838', heather_grey:'#B0B0B0',
  natural:'#F5F0EB', gray:'#808080',
};

var PRODUCTS = [];
var COLORS_BY_PRODUCT = {};

class PreviewPanel {
  constructor(container, opts) {
    this.container = container;
    this.productType = opts.productType || 'tshirt';
    this.productColor = opts.productColor || 'black';
    this.onColorChange = opts.onColorChange;
    this.onProductChange = opts.onProductChange;
    this.currentDesign = null;
    this.activeSide = 'front';
    this.canvas = null;
    this.designImg = null;
    this.zoom = 1;
    this.templateConfig = {};
    this._needsRerender = true;
    this._viewMode = '2d';
    this._3d = { rend:null, scene:null, cam:null, ctrl:null, gltf:null, texMesh:null, loaded:false };
    this._loadConfig();
    this.render();
  }

  async _loadConfig() {
    try {
      var r = await fetch(API_BASE + '/admin/templates');
      var d = await r.json();
      if (d.success) {
        this.templateConfig = d.templates;
        var newProds = [], newColors = {};
        Object.keys(d.templates).forEach(function(k){
          var v = d.templates[k];
          newProds.push({value:k, label:v.label||k, icon:v.icon||'📦'});
          newColors[k] = v.colors || ['black','white'];
        });
        PRODUCTS = newProds;
        COLORS_BY_PRODUCT = newColors;
        if (this._needsRerender) this.render();
      }
    } catch(e) { console.warn('[PP] loadConfig', e); }
  }

  // ─── Render ───
  render() {
    if (this._rendered && PRODUCTS.length > 0) {
      this._updateDropdown();
      this._updateSwatches();
      this._loadProductBackground();
      return;
    }
    this._rendered = true;
    var colors = COLORS_BY_PRODUCT[this.productType] || ['black','white'];
    var swatches = colors.map(function(c){
      var hex = COLOR_MAP[c]||'#ccc';
      return '<div class="color-swatch'+(c===this.productColor?' active':'')+'" data-color="'+c+'" style="background:'+hex+';'+(c==='white'?'border:2px solid #ddd;':'')+'" title="'+c+'"></div>';
    }.bind(this)).join('');
    var opts = PRODUCTS.map(function(p){ return '<option value="'+p.value+'"'+(p.value===this.productType?' selected':'')+'>'+p.icon+' '+p.label+'</option>'; }.bind(this)).join('');
    this.container.innerHTML = [
      '<div style="display:flex;gap:12px;margin-bottom:10px;flex-wrap:wrap;">',
        '<div style="flex:1;min-width:120px;"><label style="font-size:11px;color:#64748b;">产品</label><select id="productSelect" class="product-select">'+opts+'</select></div>',
        '<div style="flex:1;min-width:100px;"><label style="font-size:11px;color:#64748b;">颜色</label><div class="color-swatches">'+swatches+'</div></div>',
        '<div style="flex:0 0 auto;"><label style="font-size:11px;color:#64748b;">尺寸</label><select id="sizeSelect" class="product-select" style="min-width:70px;"><option value="S">S</option><option value="M" selected>M</option><option value="L">L</option><option value="XL">XL</option></select></div>',
        '<div style="flex:0 0 auto;"><label style="font-size:11px;color:#64748b;display:block;">面</label>',
          '<div style="display:flex;gap:4px;margin-top:2px;">',
            '<button id="sideFront" style="padding:4px 10px;border:1px solid #e2e8f0;border-radius:6px;cursor:pointer;font-size:11px;background:#22d3ee;color:#fff;">正面</button>',
            '<button id="sideBack" style="padding:4px 10px;border:1px solid #e2e8f0;border-radius:6px;cursor:pointer;font-size:11px;background:#fff;color:#64748b;">背面</button>',
          '</div></div>',
      '</div>',
      '<div class="preview-container" id="previewContainer">',
        '<canvas id="previewCanvas" width="460" height="460" style="border-radius:10px;box-shadow:0 2px 16px rgba(0,0,0,0.06);width:100%;height:auto;aspect-ratio:1/1;display:block;"></canvas>',
        '<div id="threeContainer" style="display:none;width:100%;aspect-ratio:1/1;border-radius:10px;overflow:hidden;box-shadow:0 2px 16px rgba(0,0,0,0.06);background:#f5f0eb;"></div>',
        '<div id="previewPlaceholder" style="display:none;width:100%;aspect-ratio:1/1;border-radius:10px;background:#f5f0eb;align-items:center;justify-content:center;color:#94a3b8;font-size:13px;">选择产品或生成设计</div>',
      '</div>',
      '<div style="display:flex;gap:8px;align-items:center;justify-content:center;margin-top:8px;">',
        '<button id="view2dBtn" style="padding:3px 12px;border:1px solid #e2e8f0;border-radius:5px;cursor:pointer;font-size:11px;background:#22d3ee;color:#fff;">2D</button>',
        '<button id="view3dBtn" style="padding:3px 12px;border:1px solid #e2e8f0;border-radius:5px;cursor:pointer;font-size:11px;background:#fff;color:#64748b;">3D</button>',
        '<button id="zoomOut" style="padding:2px 10px;border:1px solid #e2e8f0;border-radius:5px;cursor:pointer;font-size:14px;">−</button>',
        '<span id="zoomLevel" style="font-size:11px;color:#64748b;min-width:40px;text-align:center;">100%</span>',
        '<button id="zoomIn" style="padding:2px 10px;border:1px solid #e2e8f0;border-radius:5px;cursor:pointer;font-size:14px;">+</button>',
        '<button id="zoomFit" style="padding:2px 10px;border:1px solid #e2e8f0;border-radius:5px;cursor:pointer;font-size:11px;">Fit</button>',
      '</div>',
      '<div id="designInfo" style="display:none;margin-top:6px;text-align:center;font-size:11px;color:#6BCB77;">✅ 透明背景 · 可拖拽调整位置</div>'
    ].join('');
    this._bindEvents();
    this._initCanvas();
  }

  _bindEvents() {
    this.container.querySelector('#productSelect').addEventListener('change',function(e){ this.setProductType(e.target.value); }.bind(this));
    this.container.querySelectorAll('.color-swatch').forEach(function(s){ s.addEventListener('click',function(){ this.setProductColor(s.dataset.color); }.bind(this)); }.bind(this));
    this.container.querySelector('#sideFront').addEventListener('click',function(){ this._setSide('front'); }.bind(this));
    this.container.querySelector('#sideBack').addEventListener('click',function(){ this._setSide('back'); }.bind(this));
    this.container.querySelector('#view2dBtn').addEventListener('click',function(){ this._switchView('2d'); }.bind(this));
    this.container.querySelector('#view3dBtn').addEventListener('click',function(){ this._switchView('3d'); }.bind(this));
    this.container.querySelector('#zoomOut').addEventListener('click',function(){ this._zoom(-1); }.bind(this));
    this.container.querySelector('#zoomIn').addEventListener('click',function(){ this._zoom(1); }.bind(this));
    this.container.querySelector('#zoomFit').addEventListener('click',function(){ this._fitZoom(); }.bind(this));
  }

  // ─── 2D / 3D ───
  _switchView(mode) {
    this._viewMode = mode;
    var is3d = mode === '3d';
    var b2 = this.container.querySelector('#view2dBtn'), b3 = this.container.querySelector('#view3dBtn');
    b2.style.background = is3d ? '#fff' : '#22d3ee'; b2.style.color = is3d ? '#64748b' : '#fff';
    b3.style.background = is3d ? '#22d3ee' : '#fff'; b3.style.color = is3d ? '#fff' : '#64748b';
    this.container.querySelector('#previewCanvas').style.display = is3d ? 'none' : '';
    var tc = this.container.querySelector('#threeContainer');
    tc.style.display = is3d ? '' : 'none';
    if (is3d) this._initThree();
    else this._loadProductBackground();
  }

  async _initThree() {
    if (this._3d.loaded) { this._resizeThree(); return; }
    var tc = this.container.querySelector('#threeContainer');
    if (!tc) return;
    var w = tc.clientWidth || 460, h = tc.clientHeight || 460;
    try {
      // Use esm.sh for bare specifier resolution
      var THREE = await import('https://esm.sh/three@0.160.0');
      var GLTF = await import('https://esm.sh/three@0.160.0/examples/jsm/loaders/GLTFLoader.js');
      var Orbit = await import('https://esm.sh/three@0.160.0/examples/jsm/controls/OrbitControls.js');
      var scene = new THREE.Scene();
      scene.background = new THREE.Color(0xf5f0eb);
      var cam = new THREE.PerspectiveCamera(35, w/h, 0.1, 10);
      cam.position.set(0, 0.3, 2);
      var rend = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      rend.setSize(w, h);
      rend.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      tc.innerHTML = '';
      tc.appendChild(rend.domElement);
      scene.add(new THREE.AmbientLight(0xffffff, 0.6));
      var dl = new THREE.DirectionalLight(0xffffff, 1.0); dl.position.set(1, 2, 2); scene.add(dl);
      var dl2 = new THREE.DirectionalLight(0xffffff, 0.3); dl2.position.set(-1, -1, 1); scene.add(dl2);
      var ctrl = new Orbit.OrbitControls(cam, rend.domElement);
      ctrl.enableDamping = true; ctrl.dampingFactor = 0.08; ctrl.autoRotate = true; ctrl.autoRotateSpeed = 1.5;
      ctrl.minDistance = 0.5; ctrl.maxDistance = 4;
      ctrl.target.set(0, 0, 0);
      this._3d = { rend, scene, cam, ctrl, gltf: null, texMesh: null, loaded: true, THREE };
      var url = API_BASE.replace('/api','') + '/uploads/' + this.productType + '.glb';
      new GLTF.GLTFLoader().load(url, function(gltf) {
        this._3d.gltf = gltf;
        scene.add(gltf.scene);
        // Auto-fit
        var box = new THREE.Box3().setFromObject(gltf.scene);
        var size = box.getSize(new THREE.Vector3()).length();
        cam.position.set(0, 0, size * 1.2);
        cam.lookAt(0, 0, 0);
        ctrl.target.set(0, 0, 0); ctrl.update();
        if (this.currentDesign) this._applyDesign3D(gltf);
        this._animateThree();
      }.bind(this), undefined, function() { tc.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#94a3b8;font-size:11px;">3D 模型加载失败</div>'; });
    } catch(e) {
      tc.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#94a3b8;font-size:11px;">3D 暂不可用</div>';
      console.warn('[3D] init error:', e.message);
    }
  }

  _animateThree() {
    var loop = function() {
      if (!this._3d.rend || !this._3d.ctrl) return;
      requestAnimationFrame(loop.bind(this));
      this._3d.ctrl.update();
      this._3d.rend.render(this._3d.scene, this._3d.cam);
    }.bind(this);
    loop();
  }

  _resizeThree() {
    var tc = this.container.querySelector('#threeContainer');
    if (!tc || !this._3d.rend) return;
    var w = tc.clientWidth || 460, h = tc.clientHeight || 460;
    this._3d.cam.aspect = w / h; this._3d.cam.updateProjectionMatrix();
    this._3d.rend.setSize(w, h);
  }

  // ─── 3D Design Texture — UV mapped ───
  _applyDesign3D(gltf) {
    var url = this.currentDesign?.previewUrl || this.currentDesign?.url;
    if (!url) return;
    // Find the 'print' mesh in the GLB
    var printMesh = null;
    gltf.scene.traverse(function(child) {
      if (child.isMesh && (child.name === 'print' || (child.material && child.material.name === 'print'))) {
        printMesh = child;
      }
    });
    if (!printMesh) { this._legacyDesign3D(url); return; }
    // Apply design as texture to print area material
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      var c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      var tex = new (this._3d.THREE).CanvasTexture(c);
      tex.needsUpdate = true;
      printMesh.material.map = tex;
      printMesh.material.transparent = true;
      printMesh.material.opacity = 1;
      printMesh.material.color.setHex(0xffffff);
      printMesh.material.needsUpdate = true;
    }.bind(this);
    img.src = url;
  }

  // Fallback for non-UV models
  _legacyDesign3D(url) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      var c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      var tex = new (this._3d.THREE).CanvasTexture(c);
      var geo = new (this._3d.THREE).PlaneGeometry(0.5, 0.4);
      var mat = new (this._3d.THREE).MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false });
      var mesh = new (this._3d.THREE).Mesh(geo, mat);
      mesh.position.set(0, 0.1, 0.001);
      this._3d.scene.add(mesh);
      this._3d.texMesh = mesh;
    }.bind(this);
    img.src = url;
  }

  _updateDesign3D() {
    if (this._3d.texMesh) { this._3d.scene.remove(this._3d.texMesh); this._3d.texMesh = null; }
    if (this._3d.gltf) this._applyDesign3D(this._3d.gltf);
  }

  // ─── Side ───
  _setSide(side) {
    this.activeSide = side;
    ['front','back'].forEach(function(s) {
      var btn = this.container.querySelector(s==='front'?'#sideFront':'#sideBack');
      if (!btn) return;
      btn.style.background = s===side ? '#22d3ee' : '#fff';
      btn.style.color = s===side ? '#fff' : '#64748b';
    }.bind(this));
    this._loadProductBackground();
    if (this.designImg && this.canvas) {
      this.designImg.set({ flipX: side==='back' });
      this.canvas.renderAll();
    }
  }

  // ─── Zoom ───
  _zoom(dir) {
    if (!this.canvas) return;
    var z = this.canvas.getZoom();
    this._setZoom(Math.max(0.3, Math.min(4, z * (dir < 0 ? 0.85 : 1.15))));
  }

  _setZoom(level) {
    if (!this.canvas) return;
    this.canvas.setZoom(level);
    this.zoom = level;
    var l = this.container.querySelector('#zoomLevel');
    if (l) l.textContent = Math.round(level * 100) + '%';
  }

  _fitZoom() {
    if (!this.canvas || !this.designImg) return;
    var z = Math.min(2, 400/this.designImg.width, 400/this.designImg.height);
    this._setZoom(z);
    var v = this.canvas.viewportTransform;
    v[4] = 230 - (this.designImg.left + this.designImg.width*this.designImg.scaleX/2) * z;
    v[5] = 230 - (this.designImg.top + this.designImg.height*this.designImg.scaleY/2) * z;
    this.canvas.requestRenderAll();
  }

  // ─── 2D Canvas ───
  _initCanvas() {
    if (typeof fabric === 'undefined') return;
    var el = this.container.querySelector('#previewCanvas');
    if (!el) return;
    if (this.canvas) this.canvas.dispose();
    this.canvas = new fabric.Canvas(el, {
      width: 460, height: 460,
      preserveObjectStacking: true, centeredScaling: true, uniScaleTransform: true, selection: true
    });
    this._loadProductBackground();
    this.canvas.on('mouse:wheel', function(opt) {
      var z = this.canvas.getZoom();
      this._setZoom(Math.max(0.3, Math.min(4, z * (opt.e.deltaY > 0 ? 0.85 : 1.15))));
      opt.e.preventDefault();
    }.bind(this));
    this.canvas.renderAll();
  }

  _templateUrl() {
    return API_BASE.replace('/api','') + '/mockups/' + this.productType + '/' + this.productColor + '-' + this.activeSide + '.png';
  }

  _baseImageUrl() {
    var v = this.templateConfig?.[this.productType];
    var url = v?.baseImage?.[this.activeSide] || v?.baseImage?.front || '';
    return url ? (url[0] === '/' ? window.location.origin + url : url) + '?v=' + Date.now() : null;
  }

  _loadProductBackground() {
    if (!this.canvas) return;
    if (this.printGuide) { this.canvas.remove(this.printGuide); this.printGuide = null; }
    var self = this;
    // Try mockup URL first, fallback to baseImage, fallback to solid color
    var mockupUrl = this._templateUrl();
    fabric.Image.fromURL(mockupUrl, function(img) {
      if (img && img.width > 1) {
        self.canvas.setBackgroundImage(img, function() {
          self._drawPrintGuide();
          self.canvas.renderAll();
        }.bind(self), { scaleX: 460/img.width, scaleY: 460/img.height });
        return;
      }
      // Fallback: try base image from admin
      var baseUrl = self._baseImageUrl();
      if (baseUrl) {
        fabric.Image.fromURL(baseUrl, function(img2) {
          if (img2 && img2.width > 1) {
            self.canvas.setBackgroundImage(img2, function() {
              self._drawPrintGuide();
              self.canvas.renderAll();
            }.bind(self), { scaleX: 460/img2.width, scaleY: 460/img2.height });
            return;
          }
          self._fallbackBg();
        }.bind(self), { crossOrigin: 'anonymous' });
      } else {
        self._fallbackBg();
      }
    }.bind(this), { crossOrigin: 'anonymous' });
  }

  _fallbackBg() {
    if (!this.canvas) return;
    var hex = COLOR_MAP[this.productColor] || '#e2e8f0';
    this.canvas.setBackgroundColor(hex, function() {
      this._drawPrintGuide();
      this.canvas.renderAll();
    }.bind(this));
  }

  _drawPrintGuide() {
    if (!this.canvas) return;
    var cf = this.templateConfig?.[this.productType]?.printAreas?.[this.activeSide];
    if (!cf) return;
    this.printGuide = new fabric.Rect({
      left: cf.x*460, top: cf.y*460, width: cf.w*460, height: cf.h*460,
      fill: 'transparent', stroke: '#FF6B6B', strokeWidth: 2,
      strokeDashArray: [6,4], selectable: false, evented: false
    });
    this.canvas.add(this.printGuide);
  }

  _printAreaBounds() {
    var cf = this.templateConfig?.[this.productType]?.printAreas?.[this.activeSide];
    return cf ? { x:cf.x*460, y:cf.y*460, w:cf.w*460, h:cf.h*460 } : { x:0, y:0, w:460, h:460 };
  }

  _updateDropdown() {
    var sel = this.container.querySelector('#productSelect');
    if (!sel) return;
    sel.innerHTML = PRODUCTS.map(function(p){ return '<option value="'+p.value+'"'+(p.value===this.productType?' selected':'')+'>'+p.icon+' '+p.label+'</option>'; }.bind(this)).join('');
  }

  _updateSwatches() {
    var colors = COLORS_BY_PRODUCT[this.productType] || ['black','white'];
    var el = this.container.querySelector('.color-swatches');
    if (!el) return;
    el.innerHTML = colors.map(function(c) {
      var hex = COLOR_MAP[c] || '#ccc';
      return '<div class="color-swatch'+(c===this.productColor?' active':'')+'" data-color="'+c+'" style="background:'+hex+';'+(c==='white'?'border:2px solid #ddd;':'')+'" title="'+c+'"></div>';
    }.bind(this)).join('');
    el.querySelectorAll('.color-swatch').forEach(function(s){ s.addEventListener('click', function(){ this.setProductColor(s.dataset.color); }.bind(this)); }.bind(this));
  }

  _updateBackground() { this._loadProductBackground(); }

  setProductType(type) {
    if (this.productType === type) return;
    this.productType = type;
    this.onProductChange(type);
    this._updateBackground();
    if (this._viewMode === '3d' && this._3d.loaded) {
      // Reload 3D model
      if (this._3d.gltf && this._3d.gltf.scene) this._3d.scene.remove(this._3d.gltf.scene);
      if (this._3d.texMesh) { this._3d.scene.remove(this._3d.texMesh); this._3d.texMesh = null; }
      this._3d.gltf = null;
      this._3d.loaded = false;
      this._3d.rend = null;
      this._initThree();
    }
  }

  setProductColor(color) {
    if (this.productColor === color) return;
    this.productColor = color;
    this.onColorChange(color);
    this.container.querySelectorAll('.color-swatch').forEach(function(s){ s.classList.toggle('active', s.dataset.color === color); });
    this._updateBackground();
  }

  updateDesign(design) {
    if (!design) return;
    this.currentDesign = design;
    this._initCanvas();
    this._loadDesignOntoCanvas(design);
    var info = this.container.querySelector('#designInfo');
    if (info) info.style.display = 'block';
    this._setSide('front');
    if (this._3d.loaded) this._updateDesign3D();
  }

  async _loadDesignOntoCanvas(design) {
    if (!this.canvas) return;
    var url = design.previewUrl || design.url;
    if (!url) return;
    var objs = this.canvas.getObjects();
    objs.forEach(function(o){ if (o !== this.printGuide) this.canvas.remove(o); }.bind(this));
    this.designImg = null;
    try {
      var img = await new Promise(function(res, rej) {
        fabric.Image.fromURL(url, function(i) { if (i) res(i); else rej(); }, { crossOrigin: 'anonymous' });
      });
      var pa = this._printAreaBounds();
      var m = Math.min((pa.w*0.85)/img.width, (pa.h*0.85)/img.height, 1);
      img.set({
        left: pa.x + (pa.w - img.width*m)/2,
        top: pa.y + (pa.h - img.height*m)/2,
        scaleX: m, scaleY: m
      });
      img.setCoords();
      this.canvas.add(img);
      this.canvas.setActiveObject(img);
      this.designImg = img;
      this.canvas.on('object:moving', function(e){ this._constrain(e.target); }.bind(this));
      this.canvas.on('object:scaling', function(e){ this._constrain(e.target); }.bind(this));
      this._fitZoom();
      this._loadProductBackground();
    } catch(e) { console.warn('[PP] loadDesign error', e); }
  }

  _constrain(obj) {
    if (!obj) return;
    obj.setCoords();
    var pa = this._printAreaBounds();
    if (obj.left < pa.x) obj.left = pa.x;
    if (obj.top < pa.y) obj.top = pa.y;
    if (obj.left + obj.width*obj.scaleX > pa.x + pa.w) obj.left = pa.x + pa.w - obj.width*obj.scaleX;
    if (obj.top + obj.height*obj.scaleY > pa.y + pa.h) obj.top = pa.y + pa.h - obj.height*obj.scaleY;
    obj.setCoords();
  }

  getDesignData() {
    if (!this.canvas) return null;
    var dataUrl = this.canvas.toDataURL({ format: 'png', multiplier: 2 });
    return {
      designId: this.currentDesign?.id,
      side: this.activeSide,
      scaleX: (this.designImg?.scaleX||1),
      scaleY: (this.designImg?.scaleY||1),
      left: (this.designImg?.left||230),
      top: (this.designImg?.top||230),
      preview: dataUrl
    };
  }
}


// ===== shopify/cart-integration.js =====
/**
 * Cart Integration v2 — Uses Shopify Storefront API
 * No longer depends on window.Shopify.products (which doesn't exist)
 * Falls back to fetching product data via /products/{handle}.json
 */
class CartButton {
  constructor(container, { getCurrentDesign, getProductType, getProductColor, getProductSize, getTemplateConfig }) {
    this.container = container;
    this.getCurrentDesign = getCurrentDesign;
    this.getProductType = getProductType;
    this.getProductColor = getProductColor;
    this.getProductSize = getProductSize;
    this.getTemplateConfig = getTemplateConfig;
    this.enabled = false;
    this.loading = false;
    this._variantCache = {};
    this.render();
  }

  render() {
    this.container.innerHTML = [
      '<div class="cart-bar">',
        '<button class="btn-cart" id="btnCart" disabled>❤️ 加入购物车</button>',
        '<div id="cartHint" style="font-size:10px;color:#94a3b8;display:none;"></div>',
      '</div>'
    ].join('');
    this.btn = this.container.querySelector('#btnCart');
    this.hint = this.container.querySelector('#cartHint');
    this.btn.addEventListener('click', () => { if (this.enabled && !this.loading) this.addToCart(); });
  }

  setEnabled(enabled) {
    this.enabled = enabled;
    if (this.btn) this.btn.disabled = !enabled;
  }

  setHint(msg) {
    if (this.hint) { this.hint.textContent = msg; this.hint.style.display = 'block'; }
  }

  // ─── Handle mapping from admin productType → Shopify product handle ───
  _handleForType(productType) {
    var config = this.getTemplateConfig ? this.getTemplateConfig() : null;
    // 1. Try shopifyId from admin template config
    if (config && config[productType] && config[productType].shopifyId) {
      return { method: 'shopifyId', id: config[productType].shopifyId };
    }
    // 2. Fallback: known handle mapping (from Shopify API product list)
    var fallback = {
      tshirt: { handle: 'canvas-tee-270' },
      hoodie: { handle: 'heavyweight-soft-fleece-hoodie' },
      mug: { handle: '400ml-arc-custom-mug' },
      phone_case: { handle: 'coloroutine-protective-art-phone-case' },
      tote_bag: { handle: 'custom-dupont-paper-tote-bag' },
      laptop_sleeve: { handle: 'coloroutine-designer-laptop-sleeve' },
    };
    if (fallback[productType]) return { method: 'fallback', ...fallback[productType] };
    return null;
  }

  // ─── Fetch product variants from backend API (reliable) ───
  async _fetchVariants(handle) {
    if (this._variantCache[handle]) return this._variantCache[handle];
    try {
      var res = await fetch('https://ai.coloroutine.com/api/products/' + handle);
      var data = await res.json();
      if (data && data.success && data.variants && data.variants.length > 0) {
        console.log('[Cart] Fetched', data.variants.length, 'variants for', handle, '(' + data.product.title + ')');
        this._variantCache[handle] = data.variants;
        return data.variants;
      }
    } catch(e) { console.warn('[Cart] variant fetch failed:', e.message); }
    return null;
  }

  async addToCart() {
    var data = this.getCurrentDesign();
    var productType = this.getProductType();
    var color = this.getProductColor();
    var size = this.getProductSize();

    if (!data || !data.canvasData) {
      this.btn.innerHTML = '⚠️ 请先生成并选择设计';
      this.loading = false; this.btn.disabled = false;
      return;
    }

    this.loading = true;
    this.btn.disabled = true;
    this.btn.innerHTML = '⏳ 查询商品...';

    // Find variant using Storefront API
    var info = this._handleForType(productType);
    if (!info) {
      this.btn.innerHTML = '⚠️ 请在后台关联Shopify产品';
      this.setHint('前往 /admin → 基本信息 → Shopify产品 下拉选择');
      this.loading = false; this.btn.disabled = false;
      return;
    }

    var variants, variantId = null;
    if (info.method === 'shopifyId') {
      // We have a shopifyId. Fetch the product list to find matching handle
      // For now, try the fallback handles
      var fb = this._handleForType(productType);
      if (fb && fb.handle) variants = await this._fetchVariants(fb.handle);
    } else if (info.handle) {
      variants = await this._fetchVariants(info.handle);
    }

    if (variants && variants.length > 0) {
      var targetColor = (color || '').toLowerCase();
      var targetSize = (size || 'm').toLowerCase();
      // Exact match: color + size
      variantId = variants.find(function(v) {
        var t = (v.title || '').toLowerCase();
        return t.includes(targetColor) && t.includes(targetSize);
      });
      // Fallback: color only
      if (!variantId) {
        variantId = variants.find(function(v) {
          return (v.title || '').toLowerCase().includes(targetColor);
        });
      }
      // Fallback: first variant
      if (!variantId) variantId = variants[0];
      if (variantId) variantId = variantId.id;
    }

    if (!variantId) {
      this.btn.innerHTML = '⚠️ 未找到匹配商品';
      this.loading = false; this.btn.disabled = false;
      return;
    }

    this.btn.innerHTML = '⏳ 加入购物车...';

    try {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('properties[_design_url]', data.previewUrl || data.url || '');
      formData.append('properties[_product_type]', productType);
      formData.append('properties[_color]', color);
      formData.append('properties[_size]', size || 'M');
      if (data.canvasData) {
        formData.append('properties[_side]', data.canvasData.side || 'front');
        formData.append('properties[_design_scale_x]', String(data.canvasData.scaleX || 1));
        formData.append('properties[_design_scale_y]', String(data.canvasData.scaleY || 1));
        formData.append('properties[_design_left]', String(Math.round(data.canvasData.left || 230)));
        formData.append('properties[_design_top]', String(Math.round(data.canvasData.top || 230)));
      }
      formData.append('properties[_generated_by]', 'Coloroutine AI Studio');

      var res = await fetch('/cart/add.js', { method: 'POST', body: formData });

      if (res.ok) {
        this.btn.innerHTML = '✅ 已加入！去购物车';
        this.btn.className = 'btn-cart cart-added';
        this.btn.onclick = function() { window.location.href = '/cart'; };
      } else {
        var err = await res.json().catch(function(){ return {}; });
        console.warn('[Cart] Add failed:', err);
        this.btn.innerHTML = '🔄 重试';
        this.loading = false; this.btn.disabled = false;
      }
    } catch(e) {
      console.warn('[Cart] error:', e);
      this.btn.innerHTML = '🔄 重试';
      this.loading = false; this.btn.disabled = false;
    }
  }
}


// ===== ai-design-studio.js =====
/**
 * Coloroutine AI Design Studio v2 — Main Web Component
 *
 * Changes v2:
 *   - Full product switcher (15 products, auto-refresh mockup)
 *   - Transparent background indicator
 *   - Parallelized AI generation backend support
 */

class AiDesignStudio extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.state = {
      activeMode: null,
      productType: 'tshirt',
      productColor: 'black',
      productSize: 'M',
      currentDesign: null,
      generatedDesigns: [],
      isGenerating: false,
      isDarkMode: false
    };

    this.modeCards = null;
    this.canvas = null;
    this.generatePanel = null;
    this.inspirationGrid = null;
    this.previewPanel = null;
    this.cartButton = null;
  }

  connectedCallback() {
    this.render();
    this.initSubComponents();
    this.bindEvents();
    this.setMode('text-to-image');
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>/* Studio design tokens — China-safe */
/* ==========================================
   Coloroutine Creative Studio v4 — Responsive Layout
   Clean, user-friendly, works at all screen sizes
   ========================================== */

:host {
  --cr-coral:       #FF6B6B;
  --cr-warm-orange: #FFA94D;
  --cr-mint:        #6BCB77;
  --cr-ocean:       #4D96FF;

  --cr-cream:       #F5F0EB;
  --cr-deep-night:  #2D2D2D;
  --cr-graphite:    #5C5C5C;
  --cr-silver:      #94A3B8;
  --cr-pure-white:  #FFFFFF;

  --cr-primary:     var(--cr-coral);
  --cr-bg:          var(--cr-cream);
  --cr-text:        var(--cr-deep-night);
  --cr-text-secondary: var(--cr-graphite);
  --cr-text-muted:  var(--cr-silver);
  --cr-border:      rgba(45, 45, 45, 0.08);
  --cr-border-light: rgba(45, 45, 45, 0.04);
  --cr-card-bg:     var(--cr-pure-white);
  --cr-card-shadow: 0 1px 2px rgba(45,45,45,0.04), 0 2px 8px rgba(45,45,45,0.04);
  --cr-card-shadow-hover: 0 4px 12px rgba(45,45,45,0.06), 0 8px 24px rgba(45,45,45,0.04);

  --cr-font-body:    'Inter', 'Noto Sans SC', -apple-system, sans-serif;

  --cr-xs:  4px;  --cr-sm:  8px;  --cr-md:  16px;
  --cr-lg:  20px; --cr-xl:  28px; --cr-2xl: 40px;

  --cr-radius-sm:  6px;
  --cr-radius-md:  10px;
  --cr-radius-lg:  14px;
  --cr-radius-xl:  18px;
  --cr-radius-full: 9999px;

  --cr-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  font-family: var(--cr-font-body);
  color: var(--cr-text);
  background: var(--cr-bg);
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

*, *::before, *::after { box-sizing: inherit; }

/* ==========================================
   Layout
   ========================================== */

.studio-layout {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--cr-sm) var(--cr-md);
}

.studio-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--cr-sm);
  padding-bottom: var(--cr-sm);
  border-bottom: 1px solid var(--cr-border-light);
}

.studio-header .logo {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--cr-text);
}
.studio-header .logo .heart { color: var(--cr-coral); }

.theme-toggle {
  background: none; border: none;
  width: 30px; height: 30px;
  border-radius: var(--cr-radius-full);
  cursor: pointer;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--cr-transition);
}
.theme-toggle:hover { background: rgba(45,45,45,0.05); }

/* ==========================================
   Mode Tabs
   ========================================== */

.mode-cards {
  display: flex;
  gap: 2px;
  margin-bottom: var(--cr-sm);
  padding: 3px;
  background: rgba(45,45,45,0.03);
  border-radius: var(--cr-radius-lg);
}

.mode-card {
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: var(--cr-radius-md);
  background: transparent;
  cursor: pointer;
  text-align: center;
  transition: all var(--cr-transition);
  font-family: var(--cr-font-body);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.mode-card:hover { background: rgba(45,45,45,0.04); }
.mode-card.active { background: var(--cr-card-bg); box-shadow: 0 1px 3px rgba(45,45,45,0.06); }
.mode-card .mode-icon { font-size: 1rem; line-height: 1; }
.mode-card .mode-label { font-size: 0.78rem; font-weight: 500; }
.mode-card .mode-desc { display: none; }

/* ==========================================
   Workspace — Responsive Grid
   ========================================== */

.workspace {
  display: grid;
  grid-template-columns: minmax(280px, 360px) 1fr;
  grid-template-rows: auto 1fr;
  gap: var(--cr-md);
  min-height: 450px;
  align-items: start;
}

.creation-panel {
  background: var(--cr-card-bg);
  border-radius: var(--cr-radius-lg);
  border: 1px solid var(--cr-border);
  padding: var(--cr-sm) var(--cr-md);
  display: flex;
  flex-direction: column;
  gap: var(--cr-sm);
}

.preview-panel {
  background: var(--cr-card-bg);
  border-radius: var(--cr-radius-lg);
  border: 1px solid var(--cr-border);
  padding: var(--cr-sm) var(--cr-md);
  display: flex;
  flex-direction: column;
  min-height: 450px;
  grid-row: 1 / -1;
  grid-column: 2;
}

.inspiration-section {
  grid-column: 1;
  grid-row: 2;
  margin-top: var(--cr-xs);
}

.panel-label {
  font-size: 0.65rem;
  font-weight: 600;
  color: var(--cr-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 2px;
}

/* ==========================================
   Buttons
   ========================================== */

.btn-primary {
  background: var(--cr-primary);
  color: var(--cr-pure-white);
  border: none;
  border-radius: var(--cr-radius-sm);
  padding: 8px 20px;
  font-family: var(--cr-font-body);
  font-weight: 600;
  font-size: 0.82rem;
  cursor: pointer;
  transition: all var(--cr-transition);
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.btn-primary:hover { filter: brightness(1.06); box-shadow: 0 4px 12px rgba(255,107,107,0.25); transform: translateY(-1px); }
.btn-primary:active { transform: translateY(0); }
.btn-primary:disabled { opacity: 0.45; cursor: not-allowed; }

/* ==========================================
   Prompt Input
   ========================================== */

.prompt-input {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid var(--cr-border);
  border-radius: var(--cr-radius-md);
  background: var(--cr-cream);
  font-family: var(--cr-font-body);
  font-size: 0.82rem;
  color: var(--cr-text);
  transition: border-color var(--cr-transition), box-shadow var(--cr-transition);
  resize: vertical;
  min-height: 64px;
  line-height: 1.5;
}
.prompt-input:focus {
  outline: none;
  border-color: var(--cr-primary);
  box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.08);
  background: var(--cr-card-bg);
}
.prompt-input::placeholder { color: var(--cr-text-muted); font-style: italic; font-size: 0.8rem; }

.style-selector { display: flex; flex-wrap: wrap; gap: 4px; }
.style-chip {
  padding: 3px 10px;
  border-radius: var(--cr-radius-full);
  border: 1px solid var(--cr-border);
  background: var(--cr-cream);
  font-size: 0.72rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--cr-transition);
  white-space: nowrap;
}
.style-chip:hover { border-color: var(--cr-primary); }
.style-chip.active { background: var(--cr-primary); color: var(--cr-pure-white); border-color: var(--cr-primary); }

/* ==========================================
   Result Grid
   ========================================== */

.result-grid { display: grid; grid-template-columns: 1fr 1fr; gap: var(--cr-sm); margin-top: var(--cr-sm); }
.result-item {
  aspect-ratio: 1;
  border-radius: var(--cr-radius-md);
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 2px solid transparent;
  background: var(--cr-bg);
  transition: all var(--cr-transition);
}
.result-item:hover { border-color: var(--cr-primary); transform: translateY(-1px); box-shadow: var(--cr-card-shadow-hover); }
.result-item.selected { border-color: var(--cr-primary); box-shadow: 0 0 0 3px rgba(255,107,107,0.15); }
.result-item img { width: 100%; height: 100%; object-fit: contain; }
.result-item .design-style-badge {
  position: absolute; bottom: 4px; left: 4px;
  padding: 2px 7px; border-radius: var(--cr-radius-full);
  background: rgba(255,255,255,0.9); font-size: 0.62rem; font-weight: 500;
  backdrop-filter: blur(4px);
}

/* ==========================================
   Preview
   ========================================== */

.preview-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cr-bg);
  border-radius: var(--cr-radius-md);
  min-height: 360px;
  position: relative;
  overflow: hidden;
}

.preview-empty { text-align: center; color: var(--cr-text-muted); }

canvas { border-radius: var(--cr-radius-md); max-width: 100%; }

.product-controls {
  display: flex;
  gap: var(--cr-sm);
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: var(--cr-sm);
}

.variant-group label {
  display: block;
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--cr-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 3px;
}

.product-select {
  padding: 5px 8px;
  border: 1.5px solid var(--cr-border);
  border-radius: var(--cr-radius-sm);
  background: var(--cr-card-bg);
  font-size: 0.78rem;
  cursor: pointer;
  min-width: 110px;
}
.product-select:focus { outline: none; border-color: var(--cr-primary); }

.color-swatches { display: flex; gap: 5px; }
.color-swatch {
  width: 22px; height: 22px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all var(--cr-transition);
}
.color-swatch:hover { transform: scale(1.15); }
.color-swatch.active { border-color: var(--cr-primary); box-shadow: 0 0 0 2px var(--cr-primary); }

.inspiration-section {
  grid-column: 1;
  grid-row: 2;
}

.inspiration-section h3 {
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 6px;
}

.inspiration-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.inspiration-card {
  border-radius: var(--cr-radius-sm);
  overflow: hidden;
  cursor: pointer;
  border: 1px solid var(--cr-border);
  transition: all var(--cr-transition);
}
.inspiration-card:hover { transform: translateY(-1px); box-shadow: var(--cr-card-shadow-hover); }
.inspiration-card .inspiration-image {
  aspect-ratio: 1.6;
  background: var(--cr-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}
.inspiration-card .inspiration-meta { padding: 3px 6px; }
.inspiration-card .inspiration-title { font-weight: 600; font-size: 0.7rem; }
.inspiration-card .inspiration-tags { font-size: 0.6rem; color: var(--cr-text-muted); line-height: 1.2; }
.inspiration-card .try-btn {
  margin-top: 2px;
  padding: 1px 8px;
  border-radius: var(--cr-radius-full);
  background: var(--cr-primary);
  color: var(--cr-pure-white);
  font-size: 0.6rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

/* ==========================================
   Upload Zone
   ========================================== */

.upload-zone {
  border: 2px dashed var(--cr-border);
  border-radius: var(--cr-radius-lg);
  padding: var(--cr-lg) var(--cr-md);
  text-align: center;
  cursor: pointer;
  transition: all var(--cr-transition);
}
.upload-zone:hover { border-color: var(--cr-primary); background: rgba(255,107,107,0.03); }
.upload-zone .upload-icon { font-size: 1.8rem; display: block; margin-bottom: var(--cr-xs); }
.upload-zone .upload-text { font-weight: 600; font-size: 0.82rem; }

/* ==========================================
   Loading
   ========================================== */

.loading-bloom { display: flex; justify-content: center; gap: 4px; padding: var(--cr-md); }
.bloom-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: var(--cr-coral);
  animation: bloom 1.2s ease-in-out infinite;
}
.bloom-dot:nth-child(2) { animation-delay: 0.2s; }
.bloom-dot:nth-child(3) { animation-delay: 0.4s; }
@keyframes bloom { 0%,80%,100% { transform: scale(0.5); opacity: 0.2; } 40% { transform: scale(1); opacity: 1; } }

.generating-text { font-size: 0.72rem; color: var(--cr-text-muted); text-align: center; }

/* ==========================================
   Responsive
   ========================================== */

@media (max-width: 1024px) {
  .workspace {
    grid-template-columns: minmax(240px, 320px) 1fr;
  }
}

@media (max-width: 860px) {
  .workspace {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
  }
  .preview-panel { grid-row: auto; grid-column: 1; }
  .inspiration-section { grid-column: 1; grid-row: 3; }
  .inspiration-grid { grid-template-columns: repeat(3, 1fr); }
}

@media (max-width: 600px) {
  .studio-layout { padding: var(--cr-xs) var(--cr-sm); }
  .mode-card .mode-label { font-size: 0.7rem; }
  .mode-card { padding: 6px 8px; gap: 3px; }
  .workspace { gap: var(--cr-sm); }
  .inspiration-grid { grid-template-columns: 1fr 1fr; }
  .preview-container { min-height: 280px; }
}

@media (max-width: 400px) {
  .inspiration-grid { grid-template-columns: 1fr; }
  .result-grid { grid-template-columns: 1fr; }
}

</style>
      <div class="studio-layout">
        <header class="studio-header">
          <div class="logo">Coloroutine <span class="heart">❤️</span> Creative Studio</div>
        </header>

        <div id="modeCardsContainer"></div>

        <div class="workspace">
          <div class="creation-panel" id="creationPanel">
            <div class="panel-label">🎨 创作区</div>
            <div id="creationContent"></div>
          </div>
          <div class="preview-panel" id="previewPanel">
            <div id="previewContent"></div>
          </div>
          <div class="inspiration-section" id="inspirationStream"></div>
        </div>

        <div id="cartBar"></div>
      </div>`;
  }

  initSubComponents() {
    const root = this.shadowRoot;

    try {
      this.modeCards = new ModeCards(root.getElementById('modeCardsContainer'), {
        onModeChange: (mode) => this.setMode(mode)
      });
    } catch (e) {}

    try {
      if (typeof fabric !== 'undefined') {
        this.canvas = new DesignCanvas(root.getElementById('creationContent'), {
          width: 500, height: 600,
          productType: this.state.productType
        });
      }
    } catch (e) {}

    try {
      this.generatePanel = new GeneratePanel(root.getElementById('creationContent'), {
        onGenerate: (params) => this.handleGenerate(params),
        apiBase: API_BASE
      });
    } catch (e) {}

    // Preview Panel v2 — with product switcher
    try {
      this.previewPanel = new PreviewPanel(root.getElementById('previewContent'), {
        productType: this.state.productType,
        productColor: this.state.productColor,
        onColorChange: (color) => this.setProductColor(color),
        onProductChange: (type) => this.setProductType(type),
        onDesignChange: (design) => this.setDesign(design)
      });
    } catch (e) {}

    try {
      this.inspirationGrid = new InspirationGrid(root.getElementById('inspirationStream'), {
        productType: this.state.productType,
        apiBase: API_BASE,
        onTryIdea: (prompt, stylePreset) => this.tryIdea(prompt, stylePreset)
      });
    } catch (e) {}

    try {
      this.cartButton = new CartButton(root.getElementById('cartBar'), {
        onAddToCart: () => this.handleAddToCart(),
        getCurrentDesign: () => {
          var canvasData = this.previewPanel?.getDesignData ? this.previewPanel.getDesignData() : null;
          var base = this.state.currentDesign || {};
          return { ...base, canvasData };
        },
        getProductType: () => this.state.productType,
        getProductColor: () => this.state.productColor,
        getProductSize: () => this.state.productSize || 'M',
        getTemplateConfig: () => this.previewPanel ? this.previewPanel.templateConfig : {}
      });
    } catch (e) {}
  }

  bindEvents() {
    // Theme toggle removed (was non-functional)

    const creationPanel = this.shadowRoot.getElementById('creationPanel');
    creationPanel.addEventListener('dragover', (e) => {
      e.preventDefault();
      if (this.state.activeMode === 'upload') creationPanel.classList.add('dragover');
    });
    creationPanel.addEventListener('dragleave', () => creationPanel.classList.remove('dragover'));
    creationPanel.addEventListener('drop', (e) => {
      e.preventDefault();
      creationPanel.classList.remove('dragover');
      const file = e.dataTransfer.files[0];
      if (file) this.handleUpload(file);
    });
  }

  // ========== Mode Management ==========

  setMode(mode) {
    this.state.activeMode = mode;
    this.modeCards.setActive(mode);
    this.showCreationContent(mode);
    this.inspirationGrid.refresh();
  }

  showCreationContent(mode) {
    const container = this.shadowRoot.getElementById('creationContent');
    container.innerHTML = '';

    switch (mode) {
      case 'upload':
        this.renderUploadMode(container);
        break;
      case 'text-to-image':
      case 'image-to-image':
        this.generatePanel.mount(container, mode);
        break;
      default:
        container.innerHTML = `<div class="preview-empty" style="padding: var(--cr-2xl);">
          <div class="preview-empty-icon">💡</div>
          <div class="preview-empty-text">从下方选择一个灵感开始创作，或者点击上方的模式卡片</div></div>`;
    }
  }

  renderUploadMode(container) {
    container.innerHTML = `
      <div class="upload-zone" id="uploadZone">
        <div class="upload-icon">📤</div>
        <div class="upload-text">拖拽图片到这里，或者点击上传</div>
        <div class="upload-hint">支持 PNG、JPEG、WebP，最大 10MB</div>
        <input type="file" id="fileInput" accept="image/png,image/jpeg,image/webp" hidden>
      </div>
      <div id="canvasArea" class="canvas-container" style="display:none;"></div>`;

    const zone = container.querySelector('#uploadZone');
    const input = container.querySelector('#fileInput');
    zone.addEventListener('click', () => input.click());
    input.addEventListener('change', (e) => {
      if (e.target.files[0]) this.handleUpload(e.target.files[0]);
    });
  }

  // ========== Upload ==========

  async handleUpload(file) {
    this.showToast('正在处理你的图片...', 'info');
    if (!file || !file.type.startsWith('image/')) {
      this.showToast('请上传图片文件 (PNG/JPEG/WebP)', 'error');
      return;
    }

    try {
      // Try server upload first
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(`${API_BASE}/upload`, { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        this._applyUploadedImage(data.imageUrl);
        if (data.dpiWarning) this.showToast('图片分辨率偏低', 'info');
        return;
      }
    } catch(e) { /* fall through to client-side */ }

    // Client-side fallback: read as data URL
    try {
      const url = await new Promise(function(res, rej) {
        var r = new FileReader();
        r.onload = function() { res(r.result); };
        r.onerror = rej;
        r.readAsDataURL(file);
      });
      this._applyUploadedImage(url);
    } catch(e) {
      this.showToast('图片处理失败，再试一次？', 'error');
    }
  }

  _applyUploadedImage(imageUrl) {
    var container = this.shadowRoot.getElementById('creationContent');
    // Show image and "use" button
    container.innerHTML = [
      '<div style="text-align:center;padding:var(--cr-sm);">',
        '<img src="'+imageUrl+'" style="max-width:100%;max-height:160px;border-radius:var(--cr-radius-md);margin-bottom:var(--cr-sm);object-fit:contain;">',
        '<button class="btn-primary" id="btnUseUpload" style="width:100%;">✅ 使用此设计</button>',
        '<button class="btn-secondary" id="btnBackUpload" style="width:100%;margin-top:4px;">🔄 重新选择</button>',
      '</div>'
    ].join('');
    container.querySelector('#btnUseUpload').addEventListener('click', function() {
      this.state.currentDesign = { url: imageUrl, previewUrl: imageUrl, id: null };
      this.previewPanel.updateDesign(this.state.currentDesign);
      if (this.cartButton) this.cartButton.setEnabled(true);
      this.showToast('设计已加载！拖拽调整位置 🖌️', 'success');
      // Show design applied state
      container.innerHTML = [
        '<div style="text-align:center;padding:var(--cr-md);">',
          '<div style="font-size:2rem;margin-bottom:var(--cr-sm);">🎨</div>',
          '<div style="font-weight:600;font-size:0.9rem;">设计已应用 ✓</div>',
          '<div style="font-size:0.75rem;color:var(--cr-silver);margin-top:2px;">在右侧调整位置后加入购物车</div>',
          '<button class="btn-secondary" id="btnBackUpload2" style="margin-top:var(--cr-md);">🔄 重新上传</button>',
        '</div>'
      ].join('');
      container.querySelector('#btnBackUpload2').addEventListener('click', function() {
        this.renderUploadMode(container);
      }.bind(this));
    }.bind(this));
    container.querySelector('#btnBackUpload').addEventListener('click', function() {
      this.renderUploadMode(container);
    }.bind(this));
  }

  // ========== AI Generation ==========

  async handleGenerate({ mode, userInput, stylePreset, referenceImage }) {
    if (!userInput || userInput.trim().length < 2) {
      this.showToast('描述太短了，多写几个字~', 'error');
      return;
    }

    this.state.isGenerating = true;
    const container = this.shadowRoot.getElementById('creationContent');
    container.innerHTML = `
      <div class="loading-bloom">
        <div class="bloom-dot"></div><div class="bloom-dot"></div>
        <div class="bloom-dot"></div><div class="bloom-dot"></div>
        <div class="bloom-dot"></div><div class="bloom-dot"></div>
      </div>
      <div class="generating-text">AI 正在创作中…约12秒 ⚡</div>`;

    try {
      const res = await fetch(`${API_BASE}/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode, userInput, stylePreset, productType: this.state.productType, referenceImage: referenceImage || undefined })
      });

      const data = await res.json();
      this.state.isGenerating = false;

      if (!data.success) {
        this.showToast(data.error, 'error');
        this.generatePanel.mount(container, mode);
        return;
      }

      this.state.generatedDesigns = data.designs;
      this.showResultGrid(container, data.designs, mode);
      this.showToast(`为你准备了 ${data.designs.length} 个设计 ❤️`, 'success');
    } catch {
      this.state.isGenerating = false;
      this.showToast('AI 服务暂时繁忙，稍等一下~ 😊', 'error');
      this.generatePanel.mount(container, mode);
    }
  }

  showResultGrid(container, designs, mode) {
    container.innerHTML = `
      <div class="result-grid" id="resultGrid"></div>
      <div style="display:flex; gap: var(--cr-sm); margin-top: var(--cr-md);">
        <button class="btn-secondary" id="btnRetry">🔄 再生成一组</button>
        <button class="btn-primary" id="btnUseSelected" disabled>✅ 使用选中的设计</button>
      </div>`;

    const grid = container.querySelector('#resultGrid');
    let selectedIndex = -1;

    designs.forEach((design, i) => {
      const item = document.createElement('div');
      item.className = 'result-item';
      const imgSrc = design.previewUrl || design.url;
      const styleName = design.stylePreset || design.style || '';
      item.innerHTML = [
        '<img src="'+imgSrc+'" alt="Design '+(i+1)+'" loading="lazy">',
        styleName ? '<div class="design-style-badge">'+styleName+'</div>' : '',
        '<div class="select-overlay">✅</div>'
      ].join('');
      item.addEventListener('click', () => {
        grid.querySelectorAll('.result-item').forEach(el => el.classList.remove('selected'));
        item.classList.add('selected');
        selectedIndex = i;
        container.querySelector('#btnUseSelected').disabled = false;
      });
      grid.appendChild(item);
    });

    container.querySelector('#btnRetry').addEventListener('click', () => this.generatePanel.mount(container, mode));
    container.querySelector('#btnUseSelected').addEventListener('click', () => {
      if (selectedIndex >= 0) this.useDesign(designs[selectedIndex]);
    });
  }

  useDesign(design) {
    this.state.currentDesign = design;
    this.previewPanel.updateDesign(design);
    if (this.cartButton) this.cartButton.setEnabled(true);

    // Show design applied confirmation in creation panel
    const container = this.shadowRoot.getElementById('creationContent');
    container.innerHTML = [
      '<div style="text-align:center;padding:var(--cr-md);">',
        '<div style="font-size:2rem;margin-bottom:var(--cr-sm);">🎨</div>',
        '<div style="font-weight:600;font-size:0.9rem;margin-bottom:2px;">设计已应用 ✓</div>',
        '<div style="font-size:0.75rem;color:var(--cr-silver);">切换产品或颜色查看效果，或在右侧调整位置</div>',
        '<button class="btn-secondary" id="btnBackToGenerate" style="margin-top:var(--cr-md);">🔄 重新生成</button>',
      '</div>'
    ].join('');
    container.querySelector('#btnBackToGenerate').addEventListener('click', function() {
      this.generatePanel.mount(container, 'text-to-image');
    }.bind(this));
    this.showToast('设计已应用到产品预览 ✓', 'success');
  }

  // ========== Product Variants ==========

  setProductType(type) {
    this.state.productType = type;
  }

  setProductColor(color) {
    this.state.productColor = color;
  }

  setDesign(design) {
    this.state.currentDesign = design;
    this.cartButton.setEnabled(!!design);
  }

  // ========== Inspiration Try It ==========

  tryIdea(prompt, stylePreset) {
    this.setMode('text-to-image');
    requestAnimationFrame(() => this.generatePanel.fillPrompt(prompt, stylePreset));
  }

  // ========== Add to Cart ==========

  async handleAddToCart() {
    if (!this.state.currentDesign) { this.showToast('请先选择一个设计 ❤️', 'error'); return; }

    if (window.Shopify && window.Shopify.routes) {
      try {
        const variantId = 'gid://shopify/ProductVariant/123456';
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: {
            '_design_preview': this.state.currentDesign.url,
            '_product_type': this.state.productType,
            '_color': this.state.productColor,
            '_size': this.state.productSize
          }}]})
        });
        this.showToast('太棒了！已经放进购物车 ❤️', 'success');
      } catch { this.showToast('购物车暂时无法访问', 'error'); }
    } else {
      this.showToast('已加入购物车 ❤️（开发模式）', 'success');
    }
  }

  toggleDarkMode() {
    this.state.isDarkMode = !this.state.isDarkMode;
    this.classList.toggle('dark-mode', this.state.isDarkMode);
  }

  showToast(message, type = 'info') {
    const existing = this.shadowRoot.querySelector('.toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.textContent = message;
    this.shadowRoot.appendChild(toast);
    setTimeout(() => toast.remove(), 3500);
  }
}

customElements.define('ai-design-studio', AiDesignStudio);


// ==========================================
// Post-init
// ==========================================
if (typeof fabric === 'undefined') {
  console.warn('[Coloroutine Studio] Fabric.js not loaded. Canvas features disabled.');
}

console.log('🎨 Coloroutine Creative Studio ready!');
console.log('   API:', API_BASE);
console.log('   "以爱着色 / Color with Love" ❤️');

})();